import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import "./plugins/sweetalert";
import "./plugins/syncfusion";
import Clipboard from "v-clipboard";
import { TiptapVuetifyPlugin } from "tiptap-vuetify";
import VueParticles from "particles.vue";
import store from "./store";
import router from "./router";
import VueGtag from "vue-gtag";

// Page views are left to GA4 enhanced measurement, which records the initial
// load (send_page_view) and each route change (browser history events).
// vue-gtag's route tracker is disabled, as running both counted every page
// view twice.
// Only one measurement ID is configured: G-RR71R1KT02 and G-5LR0WN8EH0 are
// streams of the same GA4 property, and gtag sends each event to every
// configured ID, so reporting to both counted every event twice.
Vue.use(
  VueGtag,
  {
    pageTrackerEnabled: false,
    config: { id: "G-RR71R1KT02", params: { send_page_view: true } },
  },
  router
);

// import './registerServiceWorker';
import {
  loadCldr,
  registerLicense,
  setCulture,
  setCurrencyCode,
} from "@syncfusion/ej2-base";
import VueObserveVisibility from "vue-observe-visibility";
import VueDebounce from "vue-debounce";
import VueToast from "vue-toast-notification";
import { StripePlugin } from "@vue-stripe/vue-stripe";

// Register licensing for SyncFusion
registerLicense(process.env.VUE_APP_SYNCFUSION_KEY);

Vue.config.productionTip = false;

loadCldr(
  require("cldr-data/main/en-GB/numbers.json"),
  require("cldr-data/main/en-GB/ca-gregorian.json"),
  require("cldr-data/supplemental/numberingSystems.json"),
  require("cldr-data/main/en-GB/timeZoneNames.json")
);
setCulture("en-GB");
setCurrencyCode("GBP");

Vue.use(VueParticles);
Vue.use(Clipboard);
Vue.use(TiptapVuetifyPlugin, { vuetify, iconsGroup: "mdi" });
Vue.use(VueObserveVisibility);
Vue.use(VueDebounce);
Vue.use(VueToast, {
  position: "top-right",
  pauseOnHover: true,
  dismissible: true,
});
Vue.use(StripePlugin, {
  pk: process.env.VUE_APP_STRIPE_PUB_KEY,
  locale: "en-GB",
});

export default new Vue({
  router,
  vuetify,
  store,
  render: (h) => h(App),
}).$mount("#app");
